import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import toDollars from 'utils/to-dollars';

// Selectors
// @ts-ignore
import { makeSelectGroupedDataValueAverageEffectiveRate } from 'services/timesheetTimesheetEntriesForm/selectors';

interface OwnProps {
    pickTypeId?: number;
    groupingId?: any;
    isPieceRate?: any;
    dollars?: boolean;
}

interface StateProps {
    average?: number;
}

type Props = OwnProps & StateProps;

export class TimesheetTimesheetEntriesTableGroupingAverageEffectiveRate extends React.Component<Props> {
    render(): any {
        const { average, dollars } = this.props;
        if (!average) return null;
        return dollars ? toDollars(average) : average;
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    average: makeSelectGroupedDataValueAverageEffectiveRate()
});

export default connect<StateProps, {}, OwnProps>(mapStateToProps)(
    TimesheetTimesheetEntriesTableGroupingAverageEffectiveRate
);
